<template>
  <div class="home" @click="showExist = false">
    <van-loading size="24px" class="wait" v-if="sample_type === ' '">
      加载中...
    </van-loading>
    <div v-else>
      <!-- 头部信息 -->
      <div class="userMessage">
        <i
          v-show="access_token === null ? false : true"
          class="iconfont iconfanhui back"
          @click.stop="goback"
        ></i>
        <van-icon
          class="ellipsis"
          name="ellipsis"
          @click.stop="showExist = !showExist"
        />
        <SideBar :show="showExist"></SideBar>
        <div class="icon">
          <i v-show="gender === 'male'" class="iconfont iconsexBoy"></i>
          <i v-show="gender === 'female'" class="iconfont iconsexGirl"></i>
        </div>
        <div>
          <p>
            <span class="name">{{ name }} </span> 欢迎您
          </p>
          <p class="code">样本编号：{{ scode }}</p>
        </div>
      </div>
      <!-- 内容信息 -->
      <DiseaseList :diseaseLists="diseaseLists" :scode="scode"></DiseaseList>
    </div>
  </div>
</template>

<script>
import { Dialog, Loading } from "vant";
import SideBar from "@/components/SideBarHome.vue";
import DiseaseList from "./components/diseaseList.vue";
export default {
  name: "SmallHome",
  data() {
    return {
      access_token: "",
      showExist: false,
      name: "",
      scode: "",
      gender: "",
      sample_type: "",
      product_type: "",
      diseaseLists: [],
    };
  },
  components: {
    Dialog,
    SideBar,
    [Loading.name]: Loading,
    DiseaseList,
  },
  methods: {
    goback() {
      this.$router.push({ path: "/multiomics" });
    },
    getUser() {
      this.util.get(this.api.user, "", (res) => {
        this.name = res.name;
        this.gender = res.gender;
        this.scode = res.scode;
        this.sample_type = res.sample_type;
        this.product_type = res.product_type;
        this.util.setLS(
          "headerSign",
          JSON.stringify({
            header: res.header,
            sign: res.sign,
            // header: "dW03czM4OHQ1dXBjczdxOjE3MDIzNDkwNzc=",
            // sign: "312445BFF0C68460A25724636B36BB5B",
          })
        );
        this.getSmallProductData();
      });
    },
    getSmallProductData() {
      const params = {
        scode: this.scode,
      };
      this.util.smallGet(this.api.diseaseReport, params, (data) => {
        const highArr = [],
          higherArr = [],
          generalArr = [],
          lowerArr = [],
          lowArr = [],
          other = [];
        data.forEach((item) => {
          item.risk = parseFloat(item.risk).toFixed(3);
          item.rate = parseFloat(item.rate * 100).toFixed(4);
          switch (item.conclusion) {
            case "高风险":
              highArr.push(item);
              item.levelClass = "high";
              break;
            case "较高风险":
              higherArr.push(item);
              item.levelClass = "higher";
              break;
            case "一般风险":
              generalArr.push(item);
              item.levelClass = "general";
              break;
            case "较低风险":
              lowerArr.push(item);
              item.levelClass = "lower";
              break;
            case "低分险":
              lowArr.push(item);
              item.levelClass = "low";
              break;
            default:
              other.push(item);
              item.levelClass = "";
          }
        });
        if (highArr.length > 1) {
          highArr.sort((a, b) => parseFloat(b.risk) - parseFloat(a.risk));
        }
        if (higherArr.length > 1) {
          higherArr.sort((a, b) => parseFloat(b.risk) - parseFloat(a.risk));
        }
        if (generalArr.length > 1) {
          generalArr.sort((a, b) => parseFloat(b.risk) - parseFloat(a.risk));
        }
        if (lowerArr.length > 1) {
          lowerArr.sort((a, b) => parseFloat(b.risk) - parseFloat(a.risk));
        }
        if (lowArr.length > 1) {
          lowArr.sort((a, b) => parseFloat(b.risk) - parseFloat(a.risk));
        }
        if (other.length > 1) {
          other.sort((a, b) => parseFloat(b.risk) - parseFloat(a.risk));
        }
        this.diseaseLists = [
          ...highArr,
          ...higherArr,
          ...generalArr,
          ...lowerArr,
          ...lowArr,
          ...other,
        ];
      });
    },
  },
  created() {
    this.access_token = localStorage.getItem("access_token");
    let token = this.$route.query.token;
    if (token) {
      this.util.setLS(this.api.access_token, token);
    }
    this.getUser();
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .wait {
    position: relative;
    top: 3.5rem;
    left: 2.4rem;
    color: #000000;
  }
  .userMessage {
    position: relative;
    width: 100%;
    padding: 0.45rem 0.5rem;
    background: linear-gradient(to right, #039acd, #01d1e3);
    display: flex;
    flex-direction: row;
    align-items: center;

    .ellipsis {
      position: absolute;
      top: 0.1rem;
      right: 0.15rem;
      font-size: 0.2rem;
      color: #fff;
    }

    .back {
      position: absolute;
      top: 0.1rem;
      left: 0.1rem;
      font-size: 0.2rem;
      color: #fff;
    }
    .icon {
      width: 0.75rem;
      height: 0.75rem;
      border: 0.05rem solid #47dedd;
      line-height: 0.75rem;
      border-radius: 50%;
      text-align: center;
      margin-right: 0.1rem;
      background-color: #c7f5f5;

      .iconfont {
        font-size: 0.5rem;

        &.iconsexBoy {
          color: #00a0e8;
        }

        &.iconsexGirl {
          color: #e800db;
        }
      }
    }

    p {
      color: #fff;
      font-size: 0.1rem;

      &.code {
        font-size: 0.12rem;
      }

      .name {
        font-size: 0.15rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/smallProduct/home/index.vue